module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-patient-insurance",
    style: ({
      backgroundImage: 'url(' + _vm.props.image + ')'
    })
  }, [_c('Trigger', {
    staticClass: "custom-patient-insurance__trigger",
    attrs: {
      "props": 1
    }
  }), _c('div', {
    staticClass: "custom-patient-insurance__container"
  }, [(_vm.active) ? _c('div', {
    staticClass: "custom-patient-insurance__text custom-patient-insurance__text--desktop"
  }, _vm._l((_vm.stringToArrayTitle(_vm.props.text)), function(letter, i) {
    return _c('span', {
      key: i,
      style: ({
        animation: "slide-up .5s ease-in forwards",
        animationDelay: i * .01 + "s"
      }),
      domProps: {
        "innerHTML": _vm._s(letter)
      }
    })
  })) : _vm._e(), (_vm.active && _vm.props.text2) ? _c('div', {
    staticClass: "custom-patient-insurance__text custom-patient-insurance__text--desktop"
  }, _vm._l((_vm.stringToArrayTitle(_vm.props.text2)), function(letter, i) {
    return _c('span', {
      key: i,
      style: ({
        animation: "slide-up .5s ease-in forwards",
        animationDelay: i * .01 + _vm.currentMath(_vm.props.text) + "s"
      }),
      domProps: {
        "innerHTML": _vm._s(letter)
      }
    })
  })) : _vm._e(), (_vm.active && _vm.props.text3) ? _c('div', {
    staticClass: "custom-patient-insurance__text custom-patient-insurance__text--desktop"
  }, _vm._l((_vm.stringToArrayTitle(_vm.props.text3)), function(letter, i) {
    return _c('span', {
      key: i,
      style: ({
        animation: "slide-up .5s ease-in forwards",
        animationDelay: i * .01 + _vm.currentMath(_vm.props.text) + _vm.currentMath(_vm.props.text2) + "s"
      }),
      domProps: {
        "innerHTML": _vm._s(letter)
      }
    })
  })) : _vm._e(), (_vm.active && _vm.props.text4) ? _c('div', {
    staticClass: "custom-patient-insurance__text custom-patient-insurance__text--desktop"
  }, _vm._l((_vm.stringToArrayTitle(_vm.props.text4)), function(letter, i) {
    return _c('span', {
      key: i,
      style: ({
        animation: "slide-up .5s ease-in forwards",
        animationDelay: i * .01 + _vm.currentMath(_vm.props.text) + _vm.currentMath(_vm.props.text2) + _vm.currentMath(_vm.props.text3) + "s"
      }),
      domProps: {
        "innerHTML": _vm._s(letter)
      }
    })
  })) : _vm._e(), _c('div', {
    staticClass: "custom-patient-insurance__text custom-patient-insurance__text--mobile"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.text)
    }
  }), (_vm.props.text2) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.text2)
    }
  }) : _vm._e(), (_vm.props.text3) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.text3)
    }
  }) : _vm._e(), (_vm.props.text4) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.text4)
    }
  }) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-86393f1a","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-patient-insurance/custom-patient-insurance.pug
// module id = 657
// module chunks = 1